import { DashboardInfoWidgetViewModel } from 'src/app/modules/settings/viewModels/dashboardInfoWidgetViewModel';
import { ModifiableEntityViewModel } from '../bases/modifiableEntityViewModel';
import { EventStatuses } from 'src/app/modules/events/enums/eventStatuses';

/**
 * Represents the view model for an event, extending the ModifiableEntityViewModel.
 * Contains properties related to event details such as dates, capacity, status, and dashboard information.
 *
 * @property {number} originalId - The original identifier of the event.
 * @property {string} startDate - The start date of the event in ISO string format.
 * @property {string} endDate - The end date of the event in ISO string format.
 * @property {boolean} isVenue - Indicates if the event is a venue.
 * @property {number} capacity - The capacity of the event.
 * @property {string} duration - The duration of the event.
 * @property {EventStatuses} eventStatus - The current status of the event.
 * @property {DashboardInfoWidgetViewModel} dashboardWidgetInfo - Information for the dashboard widget related to the event.
 * @property {boolean} isSelected - Indicates if the event is currently selected.
 * @property {string} [bookedSpaceStartDate] - Optional start date for a booked space.
 * @property {string} [bookedSpaceEndDate] - Optional end date for a booked space.
 * @property {Date} [originalStartDate] - Optional original start date of the event. (Available for events that startDate has been modified to match bookedSpaceStartDate)
 * @property {Date} [originalEndDate] - Optional original end date of the event. (Available for events that endDate has been modified to match bookedSpaceEndDate)
 */
export class EventViewModel extends ModifiableEntityViewModel {
  public originalId: number;
  public startDate: string;
  public endDate: string;
  public isVenue: boolean;
  public capacity: number;
  public duration: string;
  public eventStatus: EventStatuses;
  public dashboardWidgetInfo: DashboardInfoWidgetViewModel;
  public isSelected: boolean;
  public bookedSpaceStartDate?: string;
  public bookedSpaceEndDate?: string;
  public originalStartDate?: Date;
  public originalEndDate?: Date;
  public status: EventStatuses;
  public externalId: string;
  public externalIntegrationType: number;
  public externalTenantId: string;
  public externalClusterId: string;
  public externalOrgCode: string;
}
